import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createTextNode, $isRangeSelection, RootNode } from 'lexical';
import { trimTextContentFromAnchor } from '@lexical/selection';

export const MaxLengthPlugin = ({ maxLength, mode, content, editorStateRef, isExpanded }) => {
  const [editor] = useLexicalComposerContext();
  editorStateRef.current = editor;
  useEffect(() => {
    return editor.registerNodeTransform(RootNode, (rootNode) => {
      if (mode == 'VIEW' && !isExpanded) {
        const selection = rootNode.getLastChild().selectEnd();
        if (!$isRangeSelection(selection) || !selection.isCollapsed()) {
          return;
        }
        const textContentSize = rootNode.getTextContentSize();

        if (textContentSize > maxLength) {
          const delCount = textContentSize - maxLength + 3;
          const anchor = selection.anchor;

          if (delCount > 0) {
            trimTextContentFromAnchor(editor, anchor, delCount);
            let lastNode = anchor.getNode();
            if (typeof lastNode.spliceText === 'function') {
              lastNode.spliceText(maxLength, 0, '...');
            } else {
              const textNode = $createTextNode('...');
              lastNode.append(textNode);
            }
          }
        }
      } else {
        if (content) {
          const state = editor.parseEditorState(content);
          editor.setEditorState(state);
        }
      }
    });
  }, [editor, content, isExpanded]);

  return null;
};
